import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import icOn from '../static/check_on.svg';
import icOff from '../static/check_off.svg';

const checkbox: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  lineHeight: '20px',
  fontSize: '14px',
  color: theme.color.text,
  cursor: 'pointer',
  '> input': {
    flex: 'none',
    appearance: 'none',
    width: '24px',
    height: '24px',
    margin: 0,
    background: `url(${icOff}) no-repeat center / contain`,
    outline: 'none',
    borderRadius: 6,

    ':not([disabled])': {
      cursor: 'pointer',
    },

    ':checked': {
      background: `url(${icOn}) no-repeat center / contain`,
    },

    ':disabled': {
      background: theme.color.grey75,
    },

    ':focus-visible': {
      boxShadow: `0 0 0 3px ${theme.color.grey100}`,
    },
  },
};

export { checkbox };
